// Numbered manifesto-style section label: "01 —— ABOUT"
export const ChapterLabel = ({ index, title }) => (
  <div className="flex items-center gap-4 mb-12" data-testid={`chapter-${title.toLowerCase()}`}>
    <span className="font-mono text-xs tracking-[0.2em] text-teal">{index}</span>
    <span className="h-px w-10 bg-teal/50" aria-hidden="true" />
    <span className="font-mono text-xs uppercase tracking-[0.28em] text-faint">{title}</span>
  </div>
);
